import React from 'react';
import { deleteCreativesSuccess, deleteCreativesError, requestDeleteCreatives } from 'modules/campaigns/actions';
import { INDICATION_TYPES, addIndication } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { assignCreativesApi, creativesApi } from 'services/api';
import { errorMessagesUtils } from 'services/utils';

const successIndication = {
    message: <FormattedMessage id="creatives.delete.success" defaultMessage="Ads successfully deleted" />,
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

const generateErrorIndication = (errorObject = {}) => ({
    message: errorMessagesUtils.getErrorMessage(errorObject),
    type: INDICATION_TYPES.ERROR,
    highlight: <FormattedMessage id="creatives.delete.error.highlight" defaultMessage="Unable to delete ads." />,
});

const deleteCreatives = (accountId, selectedRowsIds, shouldArchiveAds) => dispatch => {
    const creativeIds = selectedRowsIds.map(r => r.creativeId);
    const instructionsToUpdate = { ids: creativeIds };

    const adsToUpdate = {
        ids: selectedRowsIds.map(r => r.adId),
        update: {
            isArchived: true,
        },
    };
    dispatch(requestDeleteCreatives());
    const deleteCall = shouldArchiveAds
        ? assignCreativesApi.updateAds(accountId, adsToUpdate)
        : creativesApi.deleteCreatives(accountId, instructionsToUpdate);

    return deleteCall
        .then(({ results, ads }) => {
            dispatch(addIndication(successIndication));
            dispatch(deleteCreativesSuccess(results ?? ads));
        })
        .catch(error => {
            dispatch(addIndication(generateErrorIndication(error)));
            dispatch(deleteCreativesError(creativeIds ?? adsToUpdate.ids, error));
        });
};

export default deleteCreatives;
